<template>
  <div class="page home-page  scrollbar-style">
    <div class="widget-container scrollbar-style">
      <section class="widget-container-header">
          <input type="checkbox" data-role="checkbox" data-caption="Auto Arrange" v-model="widgetsAutoArrange">
      </section>
      <section class="widget-container-widgets" :class="{'auto-arrange':widgetsAutoArrange}">
        <!-- <widget id="3" title="Success" headerTextColor="#000">
          <file-folder-checker folderToCheck="successFolder" refreshInSeconds="5"></file-folder-checker>
        </widget>
        <widget id="6" title="Archives" headerTextColor="#000">
          <file-folder-checker folderToCheck="archivesFolder" refreshInSeconds="5"></file-folder-checker>
        </widget>
        <widget id="4" title="Errors" headerTextColor="#000">
          <file-folder-checker folderToCheck="errorsFolder" refreshInSeconds="5"></file-folder-checker>
        </widget>
        <widget id="5" title="Input Folder" headerTextColor="#000">
          <file-folder-checker  folderToCheck="inputFolder" :showUpload="true" :showProcessor="true" :selectable="true" refreshInSeconds="5"></file-folder-checker>
        </widget> -->

        <!-- <widget v-for="w in widgets" :key="w.id" :id="w.id" :title="w.title">
            <admin-server-summary v-if="w.type=='SERVERSTATUS'"></admin-server-summary>
            <news v-if="w.type=='NEWS'"></news>
            <rank-pie v-if="w.type=='RANKPIE'"></rank-pie>
            <firm-description-chart v-if="w.type=='SECTORSUMMARY'"></firm-description-chart>
            <pending-evaluations v-if="w.type=='PENDING'"></pending-evaluations>
            <db-counts v-if="w.type=='DBCOUNTS'"></db-counts>
            <template v-slot:menu>
              <pending-evaluations-menu v-if="w.type=='PENDING'"></pending-evaluations-menu>
              <admin-server-summary-menu v-if="w.type=='SERVERSTATUS'"></admin-server-summary-menu>
              <news-menu v-if="w.type=='NEWS'"></news-menu>
              <db-counts-menu v-if="w.type=='DBCOUNTS'"></db-counts-menu>
              <firm-description-chart-menu v-if="w.type=='SECTORSUMMARY'"></firm-description-chart-menu>
              <rank-pie-menu v-if="w.type=='RANKPIE'"></rank-pie-menu>
            </template>
        </widget> -->

        <!-- <widget id="1" title="Pending Evaluations" headerTextColor="#000">
            <pending-evaluations></pending-evaluations>
            <template v-slot:menu>
              <pending-evaluations-menu></pending-evaluations-menu>
            </template>
        </widget>
        <widget id="2" title="Totals" headerTextColor="#000">
          <db-counts></db-counts>
          <template v-slot:menu>
              <db-counts-menu></db-counts-menu>
            </template>
        </widget>
        <widget id="5" title="Business Description" headerTextColor="#000">
          <firm-description-chart></firm-description-chart>
          <template v-slot:menu>
              <firm-description-chart-menu></firm-description-chart-menu>
            </template>
        </widget>
        
        <widget id="4" title="Server Summary">
            <admin-server-summary></admin-server-summary>
            <template v-slot:menu>
              <admin-server-summary-menu></admin-server-summary-menu>
            </template>
        </widget> -->
      </section>
    </div>
  </div>
</template>

<style lang="less" scoped>
.home-page{
  padding-right:0px !important;
  padding-top:0px !important;
  padding-left:50px !important;
}
@media screen and (max-width:600px){
  .home-page{
    padding-left:0px !important;
    padding-right:0px !important;
  }
}
.widget-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  display:flex;
  flex-direction: column;
  .widget-container-header {
    height: 50px;
    width: 100%;
    padding: 10px 10px;
  }
  .widget-container-widgets {
    height: 100%;
    width:100%;
    .widget{
      position: absolute;
    }
    &.auto-arrange{
      display:flex;
      .widget{
        position:initial;
        margin:10px;
      }
    }

  }
}
</style>

<script>
import widget from "../../components/admin/widget.vue";
import fileFolderChecker from '../../components/admin/widgets/fileFolderChecker.vue';
import fileFolderCheckerMenu from '../../components/admin/widgets/fileFolderChecker-menu.vue';

export default {
  components: {
    widget,
    fileFolderChecker,
    fileFolderCheckerMenu
  },
  data() {
    return {
      widgetsAutoArrange:false,
      widgets:[]
    };
  },
  mounted() {
    const action=async ()=>{
      // let response=await axios.post(`${settings.serviceUrl}user-widget/getMany`,{
      //   tokenValue:localStorage.getItem('token'),
      //   item:{
      //    userId:this.$store.state.user.id
      // }});
      // this.widgets=response.data.payload.items;
    };
    action();
  },
  methods: {}
};
</script>